import React from "react";

function FlightCancellationQueues() {
  return <div>FlightCancellationQueues</div>;
}

export default FlightCancellationQueues;
